"use strict";

var vibrant_1 = require("./vibrant");

var browser_1 = require("./image/browser");

vibrant_1.default.DefaultOpts.ImageClass = browser_1.default;
module.exports = vibrant_1.default;